function handleCookiesClick() {
    if (typeof showCookiePreferences === 'function') {
        showCookiePreferences();
    } else if (typeof showCookiesModal === 'function') {
        showCookiesModal();
    } else {
        window.location.href = '/cookies';
    }
}

function showCookiePreferences() {}

function acceptCookies() {
    siteStorage.set('cookies-accepted', 'true');
    document.getElementById('cookies-banner').style.display = 'none';
}

function declineCookies() {
    siteStorage.set('cookies-accepted', 'false');
    document.getElementById('cookies-banner').style.display = 'none';
}

function checkCookieConsent() {
    const cookiesAccepted = siteStorage.get('cookies-accepted');
    if (cookiesAccepted === null) {
        const banner = document.getElementById('cookies-banner');
        if (banner) banner.style.display = 'block';
    }
}

document.addEventListener('DOMContentLoaded', checkCookieConsent);
